import { render, staticRenderFns } from "./AgentHeader.vue?vue&type=template&id=228f437e&"
import script from "./AgentHeader.vue?vue&type=script&lang=js&"
export * from "./AgentHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports